import { render, staticRenderFns } from "./CategoryMegaMenu.vue?vue&type=template&id=90f5c3da&scoped=true"
import script from "./CategoryMegaMenu.vue?vue&type=script&lang=js"
export * from "./CategoryMegaMenu.vue?vue&type=script&lang=js"
import style0 from "./CategoryMegaMenu.vue?vue&type=style&index=0&id=90f5c3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f5c3da",
  null
  
)

export default component.exports